import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconFlagCountry = forwardRef((props, ref) => _jsxs(Container, {
  "data-testid": "IconFlagCountry",
  viewBox: "0 0 24 24",
  ref: ref,
  ...props,
  children: [_jsx("path", {
    d: "M15.47 16.49a9 9 0 0 1-4.3-1.07 4.9 4.9 0 0 0-5.58.37.8.8 0 0 1-1.35-.6V5.5a.8.8 0 0 1 .46-.72 9.6 9.6 0 0 1 8.13.3q1.2.67 2.58.69c1.09 0 2.15-.38 3-1.07a.8.8 0 0 1 1.35.6v9.69a.8.8 0 0 1-.46.72 10 10 0 0 1-3.83.78M8.6 13.12c1.17 0 2.31.31 3.33.88 1.1.59 2.31.89 3.55.88q1.38 0 2.68-.44v-7.7a6.4 6.4 0 0 1-2.74.63 7 7 0 0 1-3.34-.88 7.4 7.4 0 0 0-3.54-.88q-1.38 0-2.68.44v7.7c.85-.42 1.8-.63 2.74-.63"
  }), _jsx("path", {
    d: "M4.24 3.8a.8.8 0 1 1 1.6 0V21h-1.6z"
  })]
}));
IconFlagCountry.displayName = 'IconFlagCountry';